import { AppContext } from 'Api/AppContext';
import { SmartObjectDto } from 'Api/Contracts/Dtos';
import VoAddOrEditSmartObjectDialog from 'App/Areas/Shares/Dialogs/VoAddOrEditSmartObjectDialog.vue';
import { injectTypes } from 'App/injectTypes';
import { lazyInject } from 'App/Inversify.config';
import { BaseDialogBehavior } from 'App/Services/DialogService/BaseDialogBehavior';
import { DialogButton } from 'App/Services/DialogService/Components/DefaultDialog.vue';
import { Component } from 'Framework/Components/UIElement';
import { DialogResult, IDialogService } from 'Framework/Services/IDialogService';
import { cloneDeep } from 'lodash';

interface ISmartObjectDialog {
    smartObject: SmartObjectDto;
    projectId: number;
}

@Component({
    name: 'VoSmartObjectDetailsDialog'
})
export default class VoSmartObjectDetailsDialog extends BaseDialogBehavior<ISmartObjectDialog> {
    public async openEditSmartObjectDialogAsync(smartObject: SmartObjectDto): Promise<void> {
        const copyOfSmartObject: SmartObjectDto = cloneDeep(smartObject);

        const result: DialogResult = await this._dialogService.openAsync(
            'Shares',
            VoAddOrEditSmartObjectDialog,
            {
                projectId: this.dataContext.projectId,
                currentSmartObject: copyOfSmartObject
            },
            {
                width: this._appContext.settings.dialogs.medium.width,
                height: this._appContext.settings.dialogs.large.height,
            });

        if (result == DialogResult.OK) {
            const _ = Object.assign(smartObject.dataSource, copyOfSmartObject.dataSource);
        }
    }

    protected readonly buttons: DialogButton = DialogButton.Custom;
    protected readonly baseTranslationPath: string = 'Areas.Explore.Components.SmartObjectPanel';

    @lazyInject(AppContext)
    private readonly _appContext: AppContext;

    @lazyInject(injectTypes.IDialogService)
    private readonly _dialogService: IDialogService;
}
